/**
 * uid — 生成唯一标识符（共享工具）
 *
 * 格式：`<timestamp>-<9位随机base36>`
 * 用于 React key、临时 ID 等场景。
 */
export const uid = () => `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
